// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const localOptions = gql`
  query localOptions {
    options @client {
      localeLanguage
      unitSystem
      timeZone
      # trendDuration
      # month
      # year
    }
  }
`;

export default localOptions;
